
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import React from 'react';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import CallToAction from '@/components/CallToAction';
import FaqTranscription from '@/components/FaqTranscription';
import FeaturedLogos from '@/components/FeaturedLogos';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import LogosCloud from '@/components/LogosCloud';
import SecurityCompliance from '@/components/SecurityCompliance';
import Seo from '@/components/Seo';
import SupportedFormats from '@/components/SupportedFormats';
import Testimonials from '@/components/Testimonials';
import ThreeStepsProcess from '@/components/ThreeStepsProcess';
import TranscriptionFeaturesSimple from '@/components/TranscriptionFeaturesSimple';
import TranscriptionStats from '@/components/TranscriptionStats';
import VideoToTextHero from '@/components/ai-transcription/VideoToTextHero';
const VideoToTextConverter = () => {
    const { t, lang } = useLocale('ai-transcription');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t('Video to Text Converter - Transcribe Video to Text Online | Easy-Peasy.AI')} description={t('Convert video to text online with our AI-powered transcription service. High accuracy, speaker detection, 40+ languages supported. Start transcribing for free!')} image={`https://easy-peasy.ai/api/og-template?title=${t('Video to Text Converter')}`}/>

      <div className='relative bg-white dark:bg-slate-900'>
        <LandingPageNavigation />
        <VideoToTextHero />
      </div>

      <LogosCloud />

      <div id='how-it-works'>
        <ThreeStepsProcess />
      </div>

      <TranscriptionStats />

      <SupportedFormats />

      <TranscriptionFeaturesSimple />

      <SecurityCompliance />

      <FeaturedLogos />

      <Testimonials />

      <FaqTranscription />

      <CallToAction preset='audios'/>

      <Footer />
    </main>);
};
export default VideoToTextConverter;
// add static props
async function getStaticProps() {
    return {
        props: {},
    };
}

    async function __Next_Translate__getStaticProps__1a1052e9117__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/video-to-text-converter',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1052e9117__ as getStaticProps }
  